"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
const react_1 = __importStar(require("react"));
const commons_1 = require("../commons");
const use_elements_props_1 = require("../hooks/use-elements-props");
const use_tracking_event_listener_1 = require("../hooks/use-tracking-event-listener");
const EmptyStyle = {};
const HiddenStyle = {
    width: '1px',
    height: '1px',
    position: 'absolute',
    visibility: 'hidden'
};
const ResetStyleSheet = {
    border: 'none',
    left: 0,
    margin: 0,
    opacity: 1,
    overflow: 'hidden',
    padding: 0,
    position: 'relative',
    top: 0
};
const AdditionalIframeProps = {
    allowtransparency: 'false',
    importance: 'high'
};
function Banner(props) {
    var _a;
    const { className, response, properties, onTrackingEvent } = props;
    const { _opts } = properties;
    const [iframeRef, setIframeRef] = (0, react_1.useState)();
    const [wrapperRef, setWrapperRef] = (0, react_1.useState)();
    const [wrapperWidth, setWrapperWidth] = (0, react_1.useState)();
    const [wrapperHeight, setWrapperHeight] = (0, react_1.useState)();
    const adContent = (0, react_1.useMemo)(() => (0, commons_1.getAdContent)(properties, response), [properties, response]);
    const elementsProperties = (0, use_elements_props_1.useElementsProps)(iframeRef, adContent);
    const elementsInitialized = elementsProperties === null || elementsProperties === void 0 ? void 0 : elementsProperties.initialized;
    const hideCreative = (elementsProperties === null || elementsProperties === void 0 ? void 0 : elementsProperties.isEmptyPersonalization) || ((_a = elementsProperties === null || elementsProperties === void 0 ? void 0 : elementsProperties.options) === null || _a === void 0 ? void 0 : _a.hideCreative);
    const autoHide = _opts === null || _opts === void 0 ? void 0 : _opts.autohide;
    const autoScale = _opts === null || _opts === void 0 ? void 0 : _opts.autoscale;
    const autoScaleMode = (_opts === null || _opts === void 0 ? void 0 : _opts.autoscale_mode) || 'fit-to-width';
    const { width, height } = (0, commons_1.getContentSize)(properties, response);
    const [autoHideStyle, setAutoHideStyle] = (0, react_1.useState)(autoHide ? HiddenStyle : EmptyStyle);
    const iframeRefCallback = (0, react_1.useCallback)((iframeNode) => {
        setIframeRef(iframeNode);
    }, []);
    const wrapperRefCallback = (0, react_1.useCallback)((wrapperNode) => {
        setWrapperRef(wrapperNode);
        const containerNode = wrapperNode === null || wrapperNode === void 0 ? void 0 : wrapperNode.parentNode;
        if (containerNode) {
            const rect = containerNode.getBoundingClientRect();
            setWrapperWidth(rect.width);
            setWrapperHeight(rect.height);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        const containerNode = wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.parentNode;
        if (autoScale && containerNode) {
            const ro = new ResizeObserver((entries) => {
                for (let entry of entries) {
                    if (entry.target === containerNode) {
                        const rect = entry.target.getBoundingClientRect();
                        setWrapperWidth(rect.width);
                        setWrapperHeight(rect.height);
                    }
                }
            });
            ro.observe(containerNode);
            return () => ro.unobserve(containerNode);
        }
        return undefined;
    }, [wrapperRef, autoScale]);
    (0, react_1.useEffect)(() => {
        if (!autoHide) {
            setAutoHideStyle(EmptyStyle);
        }
    }, [autoHide]);
    (0, react_1.useEffect)(() => {
        if (autoHide) {
            if (!elementsInitialized) {
                setAutoHideStyle(HiddenStyle);
            }
            else if (elementsInitialized && !hideCreative) {
                setAutoHideStyle(EmptyStyle);
            }
        }
    }, [elementsInitialized, autoHide, hideCreative]);
    (0, use_tracking_event_listener_1.useTrackingEventListener)(!!elementsInitialized, iframeRef, onTrackingEvent);
    const sizeStyleSheet = (0, react_1.useMemo)(() => ({
        width: width + 'px',
        height: height + 'px'
    }), [width, height]);
    const autoScaleWrapperStyleSheet = (0, react_1.useMemo)(() => {
        if (autoScale) {
            return {
                display: 'block',
                width: '100%',
                height: autoScaleMode === 'fit-to-width' ? 'auto' : '100%'
            };
        }
        else {
            return EmptyStyle;
        }
    }, [autoScale, autoScaleMode]);
    const wrapperStyleSheet = (0, react_1.useMemo)(() => ({
        display: 'inline-block',
        ...ResetStyleSheet,
        ...sizeStyleSheet,
        ...autoScaleWrapperStyleSheet,
        ...autoHideStyle
    }), [sizeStyleSheet, autoScaleWrapperStyleSheet, autoHideStyle]);
    const autoScaleHolderStyleSheet = (0, react_1.useMemo)(() => {
        if (wrapperHeight != null && wrapperWidth != null && autoScale) {
            const scaleWidth = width <= 0 ? 1 : wrapperWidth / width;
            const scaleHeight = height <= 0 ? 1 : wrapperHeight / height;
            const scaleOffsetX = Math.floor((wrapperWidth - width * scaleHeight) / 2);
            const scaleOffsetY = Math.floor((wrapperHeight - height * scaleWidth) / 2);
            const scaledHeight = Math.floor(height * scaleWidth);
            const scaledWidth = Math.floor(width * scaleHeight);
            switch (autoScaleMode) {
                case 'fit-to-width':
                    return {
                        width: '100%',
                        height: scaledHeight + 'px'
                    };
                case 'fit-to-height':
                    return {
                        width: scaledWidth + 'px',
                        height: '100%',
                        left: scaleOffsetX + 'px'
                    };
                case 'best-fit':
                    const isBestWidth = scaleHeight > scaleWidth;
                    return {
                        width: isBestWidth ? '100%' : scaledWidth + 'px',
                        height: isBestWidth ? scaledHeight + 'px' : '100%',
                        top: isBestWidth ? scaleOffsetY + 'px' : '0',
                        left: isBestWidth ? '0' : scaleOffsetX + 'px'
                    };
            }
        }
        else {
            return EmptyStyle;
        }
    }, [autoScale, autoScaleMode, width, height, wrapperWidth, wrapperHeight]);
    const holderStyleSheet = (0, react_1.useMemo)(() => ({
        display: 'block',
        ...ResetStyleSheet,
        ...sizeStyleSheet,
        ...autoScaleHolderStyleSheet
    }), [sizeStyleSheet, autoScaleHolderStyleSheet]);
    const autoScaleIframeStyleSheet = (0, react_1.useMemo)(() => {
        if (autoScale && wrapperWidth != null && wrapperHeight != null) {
            const scaleWidth = width <= 0 ? 1 : wrapperWidth / width;
            const scaleHeight = height <= 0 ? 1 : wrapperHeight / height;
            const scale = autoScaleMode === 'fit-to-width'
                ? scaleWidth
                : autoScaleMode === 'fit-to-height'
                    ? scaleHeight
                    : Math.min(scaleWidth, scaleHeight);
            return {
                transformOrigin: '0 0',
                transform: `scale(${scale.toFixed(4)})`
            };
        }
        else {
            return EmptyStyle;
        }
    }, [autoScale, autoScaleMode, width, height, wrapperWidth, wrapperHeight]);
    const iframeStyleSheet = (0, react_1.useMemo)(() => {
        return {
            ...ResetStyleSheet,
            ...sizeStyleSheet,
            ...autoScaleIframeStyleSheet
        };
    }, [sizeStyleSheet, autoScaleIframeStyleSheet]);
    const encodedSlotOptions = (0, react_1.useMemo)(() => (0, commons_1.getEncodedSlotOptions)(_opts), [_opts]);
    return (react_1.default.createElement("ins", { ref: wrapperRefCallback, style: wrapperStyleSheet, className: className },
        react_1.default.createElement("ins", { style: holderStyleSheet },
            react_1.default.createElement("iframe", { ref: iframeRefCallback, style: iframeStyleSheet, frameBorder: 0, marginWidth: 0, marginHeight: 0, scrolling: "no", loading: "eager", "data-options": encodedSlotOptions, srcDoc: adContent, ...AdditionalIframeProps }))));
}
exports.Banner = Banner;
//# sourceMappingURL=banner.js.map